import script from "./PaySuccess.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaySuccess.vue?vue&type=script&lang=ts&setup=true"

import "./PaySuccess.vue?vue&type=style&index=0&id=0080ca4a&lang=scss"

const __exports__ = script;

export default __exports__